// src/Modal.js

import { Loading } from '@nike/frame-component-library';
import PropTypes from 'prop-types'; // Import PropTypes from prop-types package
import React from 'react';

import './Modal.css'; // Create a separate CSS file for modal styles
import {
  ButtonBlack
 } from '..';

const Modal = ({
 isOpen, onClose, title, buttonName, loading, children
}) => {
  // Add 'children' to props validation
  Modal.propTypes = {
    buttonName: PropTypes.string,
    children: PropTypes.node.isRequired,
    isOpen: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
  };
  Modal.defaultProps = {
    buttonName: '',
    loading: false, // Add default value for buttonName
  };

  if (!isOpen) return null;

  return (
    <>
      {loading ? (
        <div className="common-modal-overlay">
          <div className="common-modal-content">
            <Loading />
          </div>
        </div>
    ) : (
      <div className="common-modal-overlay">
        <div className="common-modal-content">
          <h2 className="headline-2 ta-sm-c text-color-accent">{title}</h2>
          {children}
          {buttonName && <ButtonBlack label={buttonName} onClick={onClose} />}
        </div>
      </div>
    )}
    </>
  );
};

export default Modal;
